import { Theme, makeStyles } from "@material-ui/core";

const heroStyles = (imageUri: string) =>
    makeStyles((theme: Theme) => ({
        heroContent: {
            position: "relative",
            height: "274px",
            backgroundPositionX: "50%",
            backgroundPositionY: "50%",
            backgroundSize: "cover",
            color: theme.palette.primary.contrastText,
            backgroundImage: "url(" + imageUri + ")",
            [theme.breakpoints.down("xs")]: {
                height: "174px"
            }
        },
        largeHeroContent: {
            height: "847px",
            [theme.breakpoints.down("xs")]: {
                height: "600px"
            }
        },
        heroBox: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            position: "absolute",
            width: "100%",
            height: "100%",
            maxWidth: "70%"
        },
        title: {
            padding: theme.spacing(12, 0, 2, 3),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 3)
            }
        },
        text: {
            padding: theme.spacing(0, 0, 0, 3)
        },
        blackOverlay: {
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.15)"
        },
        wrapper: {
            width: "1230px",
            maxWidth: "100%",
            margin: "0 auto",
            position: "static",
            height: "100%",
            padding: "0 310px 0 30px"
        },
        crumbs: {
            padding: theme.spacing(0, 0, 4, 25),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 2)
            }
        },
        button: {
            padding: theme.spacing(0, 0, 0, 28),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 2)
            }
        },
        subheaderLarge: {
            margin: theme.spacing(15, 0, 2, 28),
            [theme.breakpoints.down("xs")]: {
                margin: theme.spacing(15, 0, 2, 2)
            },
            padding: theme.spacing(1.5, 5.625, 1.5, 5.625),
            fontSize: "14px",
            backgroundColor: theme.palette.primary.main,
            width: "auto",
            display: "inline-block"
        },
        titleLarge: {
            padding: theme.spacing(0, 0, 2, 28),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 2, 2)
            }
        },
        textLarge: {
            padding: theme.spacing(0, 0, 2, 28),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 2)
            }
        }
    }));

export const heroStylesSmall = (imageUri: string) =>
    makeStyles((theme: Theme) => ({
        heroContent: {
            position: "relative",
            height: "174px",
            backgroundPositionX: "50%",
            backgroundPositionY: "50%",
            backgroundSize: "cover",
            color: theme.palette.primary.contrastText,
            backgroundImage: "url(" + imageUri + ")",
            [theme.breakpoints.down("xs")]: {
                height: "174px"
            }
        },
        largeHeroContent: {
            height: "847px",
            [theme.breakpoints.down("xs")]: {
                height: "600px"
            }
        },
        heroBox: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            position: "absolute",
            width: "100%",
            height: "100%",
            maxWidth: "70%"
        },
        title: {
            padding: theme.spacing(0, 0, 2, 3),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 3)
            }
        },
        text: {
            padding: theme.spacing(0, 0, 0, 3)
        },
        blackOverlay: {
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.15)"
        },
        wrapper: {
            width: "1230px",
            maxWidth: "100%",
            margin: "0 auto",
            position: "static",
            height: "100%",
            padding: "0 310px 0 30px"
        },
        crumbs: {
            padding: theme.spacing(0, 0, 4, 25),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 2)
            }
        },
        button: {
            padding: theme.spacing(0, 0, 0, 28),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 2)
            }
        },
        subheaderLarge: {
            margin: theme.spacing(15, 0, 2, 28),
            [theme.breakpoints.down("xs")]: {
                margin: theme.spacing(15, 0, 2, 2)
            },
            padding: theme.spacing(1.5, 5.625, 1.5, 5.625),
            fontSize: "14px",
            backgroundColor: theme.palette.primary.main,
            width: "auto",
            display: "inline-block"
        },
        titleLarge: {
            padding: theme.spacing(0, 0, 2, 28),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 2, 2)
            }
        },
        textLarge: {
            padding: theme.spacing(0, 0, 2, 28),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 2)
            }
        }
    }));

export default heroStyles;
